/**
 * @name: controller.js
 * @description: 控制打开关闭页面标签与传递事件
 * @author: 温永江
 * @create: 2020/07/22 14:22:00
 * @update: 2020/07/22 14:22:00
 */

import Vue from 'vue';
import routerMap from '@/router/viewRouteMap';

const getRoute = async name => {
  // name是路由名
  // 从路由表中找到此路由信息
  const route = routerMap.filter(r => r.name === name)[0];
  const { menuTreeList: Menu } = await Vue.lf.getItem('login');
  // console.log(Menu)
  const quickMenu = await Vue.lf.getItem('quickMenu');
  // matchRoute是匹配到的一级或相关的一级页面
  let matchRoute = {};
  let isInner = false;
  // 如果属于内部页（二级页面），就从quickMenu里找相关的一级页面
  // 如果找不到，就再从Menu数据里找
  if (route && route.meta && route.meta.parentRoutePath) {
    isInner = true;
    // 匹配到相关联的一级页面，如果一级页面已经手动关闭，则会再从Menu数据中找
    matchRoute = quickMenu.filter(r => {
      if (r.url) {
        return (
          r.url
            .trim()
            .toLowerCase() === route.meta.parentRoutePath.trim().toLowerCase()
        );
      }
    })[0];
  }
  if (matchRoute && 'id' in matchRoute) {
  } else {
    // 如果不是内部页，或者一级页面已经关闭，就从后台返回的菜单列表数据中找
    let i = 0;
    let menuLength = Menu ? Menu.length : 0;
    while (i < menuLength) {
      const childs = Menu[i].children;
      if (childs && childs.length) {
        const len = childs.length;
        let j = 0;
        while (j < len) {
          if (isInner) {
            if (childs[j].url === route.meta.parentRoutePath) {
              matchRoute = childs[j];
              break;
            }
          } else if (childs[j].url === route.path) {
            matchRoute = childs[j];
            break;
          }

          if(childs[j].children && childs[j].children.length) {
            let k = 0;
            let children = childs[j].children
            let length = children.length;
            while(k<length) {
              if (isInner) {
                if (children[k].url === route.meta.parentRoutePath) {
                  matchRoute = children[k];
                  break;
                }
              } else if (children[k].url === route.path) {
                matchRoute = children[k];
                break;
              }
              k++;
            }
          }

          j++;
        }
        
      }
      if (matchRoute && 'id' in matchRoute) {
        break;
      }
      i++;
    }
  }
  return isInner
    ? {
        id: name,
        url: `${route.path}`,
        name: route.meta.title
      }
    : {
        id: matchRoute.id,
        url: `${matchRoute.url}`,
        name: matchRoute.name,
        code: matchRoute.code
      };
};
// 由main.vue页面接收自定义事件
export default {
  login() {
    window.top.dispatchEvent(new CustomEvent('login'));
  },
  // 告诉window.top打开一个页签
  async open({ name, query, params, title }, routename = '' /* 打开并关闭一个 */) {
    // 从路由表中找到此路由信息
    const route = await getRoute(name);
    // console.log(route);
    let closeRoute = null;
    if (routename) {
      if (typeof routename === 'string') {
        closeRoute = await getRoute(routename);
      } else {
        closeRoute = routename;
      }
    }
    // console.log(routename, closeRoute);
    if (route) {
      const detail = {
        ...route,
        name: title || route.name,
        query,
        params,
        closeRoute: closeRoute
      };
      const tabItem = new CustomEvent('opentab', {
        detail
      });
      window.top.dispatchEvent(tabItem);
    } else {
      console.warn(`没有匹配到${name}路由`);
    }
  },
  // 关闭一个页签
  async close(routename) {
    const route = await getRoute(routename);
    const closeTabItem = new CustomEvent('closetab', {
      detail: route
    });
    window.top.dispatchEvent(closeTabItem);
  },
  async getQuickMenu() {
    await Vue.lf.getItem('quickMenu').then(data => data || []);
  },
  async getMenuByRoutePath(path) {
    const { menus: Menu } = await Vue.lf.getItem('login');
    let i = 0;
    let menuLength = Menu.length;
    let matchRoute = {};
    while (i < menuLength) {
      const childs = Menu[i].childs;
      if (childs && childs.length) {
        const len = childs.length;
        let j = 0;
        while (j < len) {
          if (childs[j].url === path) {
            matchRoute = childs[j];
            break;
          }
          j++;
        }
      }
      if (matchRoute && 'id' in matchRoute) {
        break;
      }
      i++;
    }
    return matchRoute;
  },
  // 不依赖路由表
  OPEN(route, closeRoute) {
    let url = (route.url || route.url).trim();
    let firstChar = url.charAt(0);
    if (firstChar == '/') {
      url = `#${url}`;
    } else if (firstChar != '#' || firstChar != '/') {
      url = `#/${url}`;
    }
    let basePath = route.basePath;
    if (basePath) {
      basePath = basePath.trim();
    } else {
      basePath = '';
    }
    url = basePath + url;

    const detail = {
      id: `${route.id || route.id}`.trim(), // id是自定义的页面唯一的标示，可随意，但同一页面的id必须相同
      url: url, // 例子：#/path
      // TODO，其他独立项目嵌入此主项目时，需要配置基础路径，即独立项目文件夹名，此文件夹是放在主项目根目录下的
      basePath: basePath,
      name: (route.title || route.Title).trim(), // tab的name
      query: route.Query || route.query,
      params: route.Params || route.params,
      closeRoute: closeRoute
    };

    const tabItem = new CustomEvent('opentab', {
      detail
    });
    window.top.dispatchEvent(tabItem);
  }
};
